import _axios from '@/utils/request'

// 获取专家课程信息列表
export function postExpertSeminarList (params) {
    return _axios('post', `/ms-shulan-hospital/v1/expertseminar/list`, params)
}

// 根据医生姓名或者手机号模糊查询
export function postPhoneOrName (params) {
    return _axios('post', `/ms-shulan-hospital/v1/doctor/listDoctor`, params)
}

// 添加专家课程信息
export function postExpertseminar (params) {
    return _axios('post', `/ms-shulan-hospital/v1/expertseminar`, params)
}

// 删除专家讲堂列表
export function deleteExpertSeminar (expertSeminarId) {
    return _axios('delete', `/ms-shulan-hospital/v1/expertseminar/expert_seminar_id/${expertSeminarId}`)
}

// 根据Id专家讲堂
export function getExpertSeminar (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/expert_seminar_id/${expertSeminarId}`)
}

// 更新专家课程信息
export function putExpertSeminar (params) {
    return _axios('put', `/ms-shulan-hospital/v1/expertseminar/update`, params)
}

// 上架专家讲堂列表
export function getExpertSeminarGrounding (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/grounding/${expertSeminarId}`)
}

// 下架专家讲堂列表
export function getExpertSeminarDismounte (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/dismounte/${expertSeminarId}`)
}

// 上移
export function getMoveUp (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/move_up/${expertSeminarId}`)
}

// 下移
export function getMoveDown (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/move_down/${expertSeminarId}`)
}

// 设置精品课程
export function getGoodCourse (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/set_excellent_course/${expertSeminarId}`)
}
// 取消精品课程
export function getCancleGoodCourse (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/cancle_excellent_course/${expertSeminarId}`)
}

// 精品课程上移
export function getGoodsMoveUp (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/move_up_excellent_course/${expertSeminarId}`)
}

// 精品课程下移
export function getGoodsMoveDown (expertSeminarId) {
    return _axios('get', `/ms-shulan-hospital/v1/expertseminar/move_down_excellent_course/${expertSeminarId}`)
}

// 考试列表
export function getExamList (params) {
    return _axios('get', `/ms-exam/api/exam/v1/examination/examinationList`, params)
}

// 绑定的试卷列表
export function postRelation (params) {
    return _axios('post', `/ms-shulan-hospital/v1/exam/${params.relationId}`, params)
}

// 绑定试卷
export function postAddExam (params) {
    return _axios('post', `/ms-shulan-hospital/v1/exam/add`, params)
}
